import { alertClasses, buttonBaseClasses, svgIconClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useInlineAlertStyles = makeStyles()(theme => ({
  centralizedItems: {
    width: '100%',

    [`& > .${alertClasses.icon}`]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    [`& > .${alertClasses.action}`]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      paddingTop: 0,
      marginRight: theme.spacing(-1),

      [`& > .${buttonBaseClasses.root}`]: {
        padding: 0,
        height: 24,
        width: 24,

        [`& > .${svgIconClasses.root}`]: {
          height: 24,
          width: 24,
          color: theme.palette.grey[900],
        },

        borderRadius: '50%',
        backgroundColor: 'unset',
        border: 'none',

        '&:hover': {
          border: 'none',
        },
      },
    },
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  childrenRoot: {
    marginTop: theme.spacing(-1),
  },
}));
